import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '..';
import { CONTROLLERS, ENDPOINTS } from '../../constants';
import {
  ARByDosResp,
  ARByPatientResp,
  ARByPayorByIdResp,
  ARByPayorResp,
  ARListReq,
  ARTargetList,
  ARTargetListResp,
  Response,
  TargetListFilter,
  TargetListsDetailsResp,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class ARAutomationService {
  private api: string = CONTROLLERS.TENANTS.AR_AUTOMATION;
  constructor(private apiService: ApiService) {}

  getARByDOSList(arByDosListReq: ARListReq): Observable<Response<ARByDosResp>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.AR_AUTOMATION.GET_AR_BY_DOS}`,
      arByDosListReq
    );
  }

  getARByPatientList(
    arByPatientListReq: ARListReq
  ): Observable<Response<ARByPatientResp>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.AR_AUTOMATION.GET_AR_BY_PATIENT}`,
      arByPatientListReq
    );
  }

  getARByPayorList(
    arByPayorListReq: ARListReq
  ): Observable<Response<ARByPayorResp>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.AR_AUTOMATION.GET_AR_BY_PAYOR}`,
      arByPayorListReq
    );
  }

  getARByPayorById(
    arByPayorByIdReq: ARListReq
  ): Observable<Response<ARByPayorByIdResp>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.AR_AUTOMATION.GET_AR_BY_PAYOR_BY_ID}`,
      arByPayorByIdReq
    );
  }

  getARTargetList(
    arTargetListReq: ARListReq
  ): Observable<Response<ARTargetListResp>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.AR_AUTOMATION.TARGET_LISTS}`,
      arTargetListReq
    );
  }

  getARTargetListById(
    id: number,
    practiceId: number
  ): Observable<Response<TargetListFilter>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.AR_AUTOMATION.TARGET_LIST_BY_ID}`,
      {
        id,
        practiceId,
      }
    );
  }

  // for dropdown
  getARTargetListByPracticeId(
    practiceId: number
  ): Observable<Response<ARTargetList[]>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.AR_AUTOMATION.TARGETS_BY_PRACTICE_ID}`,
      {
        practiceId,
      }
    );
  }

  getPatientsByARTarget(
    arTargetListDetailsByIdReq: ARListReq
  ): Observable<Response<TargetListsDetailsResp>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.AR_AUTOMATION.TARGET_LISTS_DETAILS}`,
      arTargetListDetailsByIdReq
    );
  }

  createTargetList(targetList: TargetListFilter) {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.AR_AUTOMATION.CREATE_TARGET_LISTS}`,
      targetList
    );
  }

  editTargetList(targetList: TargetListFilter) {
    return this.apiService.put(
      '',
      `${this.api}/${ENDPOINTS.TENANTS.AR_AUTOMATION.EDIT_TARGET_LISTS}`,
      targetList
    );
  }

  deleteTargetList(targetListsId: number) {
    return this.apiService.delete(
      targetListsId.toString(),
      `${this.api}/${ENDPOINTS.TENANTS.AR_AUTOMATION.DELETE_TARGET_LISTS}`
    );
  }
}
